import React, { useRef, useState, useEffect } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import { Tab } from "@headlessui/react";
import SkeletonLoader from "components/skeletonLoader";
import SpecialTab from "./tabs/special";
import RegularTab from "./tabs/regular";
import { useLeague } from "context/leagueContext";
import { RoundProvider } from "context/roundContext";
import Round from "views/userLeague/rounds/roundContent";
import { useGame } from "context/gameContext";
import { useTranslation } from "react-i18next";
import { classNames } from "utils/utils";
import Winners from "components/leagueCard/content/winners";

const Rounds = ({ loading }) => {
  const {
    state: { selectedRoundIndex, allRounds, leagueInfo, leagueUserData },
    dispatch,
  } = useLeague();

  const {
    state: { userGameData },
  } = useGame();
  const { t } = useTranslation();

  const container = useRef(null);

  const [updatedSelectedRoundIndex, setUpdatedSelectedRoundIndex] =
    useState(undefined);

  let gameTypeText =
    leagueInfo?.gameType === 0
      ? t("common.gametypes.season")
      : t("common.gametypes.playoff");

  let index =
    updatedSelectedRoundIndex !== undefined
      ? updatedSelectedRoundIndex
      : selectedRoundIndex;

  /*   useEffect(() => {
  let index =
    updatedSelectedRoundIndex !== undefined
      ? updatedSelectedRoundIndex
      : selectedRoundIndex;
    if (
      container.current &&
      index !== undefined &&
      container.current.childNodes[index]
    ) {
      container.current.childNodes[index].scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "center",
      });
    }
  }, [container.current, selectedRoundIndex, updatedSelectedRoundIndex]); */

  useEffect(() => {
    if (
      container.current &&
      index !== undefined &&
      container.current.childNodes[index]
    ) {
      setTimeout(() => {
        container.current.childNodes[index].scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "center",
        });
      });
    }
  }, [container.current, index]);

  const tabList = allRounds
    .filter(function (item) {
      const roundDetail = leagueInfo?.rounds[item.id];

      if (leagueInfo?.gameType == 0) {
        return true;
      } else {
        if (leagueInfo.settled && roundDetail?.settled) {
          return true;
        } else if (leagueUserData?.gameOver) {
          const isPassed = leagueUserData.passedRounds?.some(
            (el) => el === item.id
          );
          const isExitRound = leagueUserData.exitRound === item.id;
          const isSettled = roundDetail?.settled;
          const isDeadlineExpired = item.deadline.seconds * 1000 < new Date();

          if (
            (isPassed || isExitRound || isSettled || isDeadlineExpired) &&
            !leagueInfo.settled
          ) {
            return true;
          }
        } else if (leagueInfo.settled && !roundDetail?.settled) {
          return false;
        } else {
          return true;
        }
      }
    })
    .map((round, id) => {
      if (leagueInfo?.gameRule == 2) {
        return <SpecialTab roundData={round} id={id} />;
      } else {
        return <RegularTab roundData={round} id={id} />;
      }
    });

  const roundContent = allRounds?.map((round, id) => {
    return (
      <div
        className="w-full font-medium flex-end flex items-center justify-between flex-col focus:outline-none"
        key={id}
      >
        <RoundProvider>
          <Tab.Panel key={round.id} className=" flex w-full flex-col">
            <Round roundData={round} />
          </Tab.Panel>
        </RoundProvider>
      </div>
    );
  });

  return (
    <div className="w-full">
      {loading || selectedRoundIndex == "undefined" ? (
        <div className="flex flex-col">
          <SkeletonLoader type={"tabCard"} amount={3} horizontal={true} />
        </div>
      ) : (
        <Tab.Group
          selectedIndex={
            updatedSelectedRoundIndex !== undefined
              ? updatedSelectedRoundIndex
              : selectedRoundIndex
          }
          onChange={setUpdatedSelectedRoundIndex}
        >
          <div className="flex h-fit rounded-t-md relative mb-4  bg-gradient-to-b from-transparent via-black/20 to-black/80">
            <img
              src={leagueInfo?.leagueImage}
              className={classNames(
                leagueInfo?.settled ? "h-40" : "h-14 ",
                (leagueInfo?.settled || leagueUserData?.gameOver) &&
                  "grayscale opacity-50",
                "w-full object-cover object-center rounded-t-md "
              )}
              alt="Logo"
            />

            <div
              className={classNames(
                leagueInfo?.settled ? "h-40" : "h-14 ",
                "absolute flex flex-col w-full justify-between"
              )}
            >
              <div className="flex justify-between p-2 bg-gradient-to-b to-transparent via-black/60 from-black/80">
                <div className="flex items-center justify-center ">
                  <img
                    src={
                      leagueInfo?.leagueFlag
                        ? leagueInfo?.leagueFlag
                        : leagueInfo?.leagueIcon
                    }
                    className="rounded-full w-8 h-8 object-cover shrink-0 "
                    alt="Logo"
                  />
                  <div className="grid w-full overflow-hidden pl-2  flex-col">
                    <div className="text-sm text-white truncate whitespace-nowrap font-medium">
                      {leagueInfo?.name}
                    </div>
                    <div className=" font-normal text-xs text-white truncate whitespace-nowrap -mt-0.5">
                      {leagueInfo?.gameTypeId !== undefined
                        ? t(
                            "createTournament.steps.setSelectedGame.types.titles." +
                              leagueInfo?.gameTypeId
                          )
                        : "-"}
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <div
                    className={classNames(
                      leagueInfo?.settled
                        ? "text-black bg-white/70"
                        : leagueUserData?.gameOver
                        ? "text-white bg-red-500"
                        : leagueInfo?.gameType == 0
                        ? "bg-headerPrimary text-white"
                        : "bg-black text-white",
                      "flex rounded-md  text-xs px-2 py-0.5 h-fit w-fit "
                    )}
                  >
                    {leagueInfo?.settled
                      ? t("common.league_ended")
                      : leagueUserData?.gameOver
                      ? t("common.game_over")
                      : gameTypeText}
                  </div>
                </div>
              </div>
              {leagueInfo?.settled && leagueInfo?.winners?.length && (
                <Winners tournament={leagueInfo} />
              )}
            </div>
          </div>
          <Tab.List className="flex">
            <ScrollContainer
              className="scroll-container flex pl-2 pb-4 space-x-2 group"
              vertical={false}
              innerRef={container}
            >
              {tabList}
            </ScrollContainer>
          </Tab.List>
          <Tab.Panels className="px-2">
            {loading ? (
              <div className="mt-6">
                <SkeletonLoader type={"eventCard2"} amount={3} />
              </div>
            ) : (
              roundContent
            )}
          </Tab.Panels>
        </Tab.Group>
      )}
    </div>
  );
};

export default Rounds;
